import { ExperimentsHubContent } from './ExperimentsHubContent';

export function ExperimentsHub() {
  return <ExperimentsHubContent className="px-3 py-3 lg:px-10 lg:py-6" />;
}
